import {Dictionary} from '@/types'

function mountKey(key: string, name: string): string {
    return `${key}:${name}`
}

function get(storage: Storage, key: string, target: Dictionary, name: string): any {
    if (!target[name]) {
        target[name] = JSON.parse(storage.getItem(mountKey(key, name)) || 'null')
    }

    return target[name] || null
}

function set(storage: Storage, key: string, target: Dictionary, name: string, value: any): boolean {
    target[name] = value

    storage.setItem(mountKey(key, name), JSON.stringify(value))

    return true
}

export default function storageProxy<T extends Dictionary>(storage: Storage, key: string, defaults: T): T {
    return new Proxy<T>(defaults, {
        get: get.bind(undefined, storage, key),
        set: set.bind(undefined, storage, key)
    })
}
